import { Form, Select } from 'antd';
import { useMemo, useState } from 'react';

import useProductStore from '@/features/Product/store/ProductStore';
import { isEmptyString } from '@/utils/util';

import { SCRAPER_REQ_FIELD_KEY } from '../../configs/scraper-field-map/field-const';

export const ProductNameField = (props: { required?: boolean }) => {
  const { required = false } = props;
  const productMap = useProductStore((state) => state.productMap);

  const [tempProductNameOptions, setTempProductNameOptions] = useState<
    string[]
  >(
    Array.from(productMap.values())
      .map((product) => product.product_name || '')
      .filter((name) => !isEmptyString(name)),
  );

  const uniqueProductNameOptions = useMemo(() => {
    return [...new Set(tempProductNameOptions)].map((name) => ({
      label: name,
      value: name,
    }));
  }, [tempProductNameOptions]);

  return (
    <>
      <Form.Item
        name={SCRAPER_REQ_FIELD_KEY.PRODUCT_NAME}
        required={required}
        rules={
          required
            ? [{ required: true, message: 'Product name is required' }]
            : []
        }
        hidden
      >
        <input />
      </Form.Item>

      {/* Display Form.Item with render function */}
      <Form.Item label="Product name" shouldUpdate required={required}>
        {({ getFieldValue, setFieldValue }) => {
          const currentProductName: string = getFieldValue(
            SCRAPER_REQ_FIELD_KEY.PRODUCT_NAME,
          );
          return (
            <Select
              value={currentProductName ? [currentProductName] : []}
              options={uniqueProductNameOptions}
              placeholder="Select product name"
              mode="tags"
              maxTagCount={1}
              onSelect={(value) => {
                setFieldValue(SCRAPER_REQ_FIELD_KEY.PRODUCT_NAME, value);
                if (value && !tempProductNameOptions.includes(value)) {
                  setTempProductNameOptions((prev) => [...prev, value]);
                }
              }}
              onDeselect={() => {
                setFieldValue(SCRAPER_REQ_FIELD_KEY.PRODUCT_NAME, '');
              }}
            />
          );
        }}
      </Form.Item>
    </>
  );
};
